module.exports = __webpack_public_path__ + "static/img/10.a9eb081.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/eng/10.png
// module id = PcYH
// module chunks = 0